/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2020/3/25
 */
function toArray(arr = []) {
    if (!Array.isArray(arr)) {
        return [arr]
    }

    return arr
}

export function hzDvaConfigMerge(lastConfig = {}, config = {}){
    const newConfig = {}

    newConfig.plugins = [...toArray(lastConfig.plugins), ...toArray(config.plugins)]
    newConfig.config = {
        ...lastConfig.config,
        ...config.config,
        ...{
            onAction: [...toArray(lastConfig?.config?.onAction), ...toArray(config?.config?.onAction)],
            extraEnhancers: [...toArray(lastConfig?.config?.extraEnhancers), ...toArray(config?.config?.extraEnhancers)],
        }
    }

    return newConfig
}
